
import Immutable from "seamless-immutable";
import { CARE_BALANCE_ACTION_TYPES } from './careBalanceActions';



const loadPersistedState = () => {
  try {
    const serializedState = localStorage.getItem("careBalanceState");
    if (serializedState === null) {
      return undefined;
    }
    const parsedState = JSON.parse(serializedState);
    return Immutable(parsedState);
  } catch (err) {
    console.error("Failed to load state from localStorage", err);
    return undefined;
  }
};


const initialState =
  loadPersistedState() ||
  Immutable({
    singleTransaction: null,
  });

export default function careBalanceReducer(state = initialState, action) {
  switch (action.type) {
    case CARE_BALANCE_ACTION_TYPES.SET_SINGLE_TRANSACTION:
      const newState = state.merge({
        singleTransaction: action.payload,
      });

      const serializedState = JSON.stringify(newState);
      localStorage.setItem("careBalanceState", serializedState);
      return newState;

    default:
      return state;
  }
}

